import { render } from "./ComplaintsModal.vue?vue&type=template&id=5bd766ee"
import script from "./ComplaintsModal.vue?vue&type=script&lang=js"
export * from "./ComplaintsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__